'use client'

import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { ChevronDownIcon, ClockIcon } from '@heroicons/react/24/outline'
import Heading from '@tebuto/typography/Heading'
import { ReactNode } from 'react'

interface IStep {
    number: number
    title: string
    minutes: number
    children: ReactNode
}

export default function Step({ number, title, minutes, children }: IStep) {
    return (
        <Disclosure as="div" className="bg-white shadow-md md:px-12 px-6 py-6 rounded-lg border">
            {({ open }) => (
                <>
                    <DisclosureButton className="flex items-center justify-between gap-8 relative w-full">
                        <div className="w-full text-left">
                            <p className="uppercase font-medium font-left text-gray-500">{number}. Schritt</p>
                            <Heading level={3} className="my-1 tracking-tight">
                                {title}
                            </Heading>
                            <p className="flex gap-2 items-center text-primary-600">
                                <ClockIcon className="h-5 w-5 " />
                                {minutes} min
                            </p>
                        </div>
                        <div>
                            <ChevronDownIcon
                                className={`h-8 w-8 stroke-2 text-primary-600 duration-300 transition-all ${open ? 'rotate-180' : ''}`}
                            />
                        </div>
                    </DisclosureButton>
                    <DisclosurePanel as="div" className="py-12">
                        {children}
                    </DisclosurePanel>
                </>
            )}
        </Disclosure>
    )
}
